import React from "react";
import styles from "./UserImage.module.scss";
import Image from "next/image";

interface UserImageProps extends React.HTMLAttributes<HTMLDivElement> {
  image: string;
}

export const UserImage = ({ image, ...props }: UserImageProps) => {
  return (
    <div {...props} className={styles["user-image"]}>
      <Image src={image} fill alt="avatat" />
    </div>
  );
};
